import React from "react";
import {
  CommonMFE,
  MFE_NAMES,
  ReactMFE,
  Helpers,
} from "@tpd-web-common-libs/nodejs-library";
import { ContainerDiv } from "./App.style";
import styled from "@emotion/styled";
import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";

const App = (props: CommonMFE.Types.TRemoteProps) => {
  const { __host__, config, isEditMode, id: containerID } = props;
  const goBack = Helpers.EnvironmentHelper.isClientSide()
    ? document.querySelectorAll('[data-testid="go-back"]')
    : undefined;
  const title = config["Titolo"];
  const subtitle = config["SottoTitolo"];
  const titleComponentType = title["componentType"];
  const subtitleComponentType = subtitle["componentType"];

  return (
    <>
      {Helpers.RemoteHelper.getIsPrimaryVisible(config, isEditMode) && (
        <ContainerDiv
          {...Helpers.RemoteHelper.getPrimaryRemoteContainerStyleData(config)}
          className="tpd-titolo-sottotitolo-container"
        >
          <div
            className={`content-wrapper ${
              __host__.url.includes("aggiornamento-profilo")
                ? "horizontal-margin-aggiornamento-profilo"
                : ""
            }`}
          >
            <div
              className={`text-container ${
                __host__.url !== "/servizio-clienti/reclami" ? "margin" : ""
              } ${goBack && goBack.length > 0 ? "tpd_no_margin" : ""}`}
            >
              <div className="title" id="mainTitlePage">
                <ReactMFE.Remote
                  id={CommonMFE.generateID(
                    containerID,
                    `${MFE_NAMES.tpdTitoloSottotitolo}-Titolo`
                  )}
                  __deps__={React}
                  __host__={__host__}
                  __mfeName__={MFE_NAMES.tpdShortText}
                  isEditMode={isEditMode}
                  componentType={titleComponentType}
                  {...title}
                />
              </div>
              <div className="paragraph">
                <ReactMFE.Remote
                  id={CommonMFE.generateID(
                    containerID,
                    `${MFE_NAMES.tpdTitoloSottotitolo}-${MFE_NAMES.richText}`
                  )}
                  __deps__={React}
                  __host__={__host__}
                  __mfeName__={MFE_NAMES.richText}
                  isEditMode={isEditMode}
                  componentType={subtitleComponentType}
                  {...subtitle}
                />
              </div>
            </div>
          </div>
        </ContainerDiv>
      )}
    </>
  );
};

export default ReactMFE.PrimaryRemoteHOCFactory(
  React,
  styled,
  { CacheProvider },
  createCache
)(App);
